(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-feature-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-featured-slider')) {
    class CustomFeaturedSlider extends HTMLElement {
      connectedCallback() {
        this.slider = this.querySelector('.product-grid.slider');
        this.track = this.querySelector(
          '.custom-featured-collection__scrollbar'
        );
        this.thumb = this.querySelector(
          '.custom-featured-collection__scrollbar-thumb'
        );

        if (!this.slider || !this.track || !this.thumb) return;

        this.updateScrollbar = this.updateScrollbar.bind(this);

        this.slider.addEventListener(
          'scroll',
          this.updateScrollbar,
          { passive: true }
        );

        this.resizeObserver = new ResizeObserver(
          this.updateScrollbar
        );

        this.resizeObserver.observe(this.slider);
        this.resizeObserver.observe(this.track);

        requestAnimationFrame(this.updateScrollbar);
      }

      disconnectedCallback() {
        if (this.slider && this.updateScrollbar) {
          this.slider.removeEventListener(
            'scroll',
            this.updateScrollbar
          );
        }

        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }
      }

      updateScrollbar() {
        const trackWidth = this.track.clientWidth;

        const maxScroll =
          this.slider.scrollWidth -
          this.slider.clientWidth;

        const visibleRatio = Math.min(
          this.slider.clientWidth /
            this.slider.scrollWidth,
          1
        );

        const thumbWidth = Math.max(
          trackWidth * visibleRatio,
          40
        );

        const maxThumbTravel = Math.max(
          trackWidth - thumbWidth,
          0
        );

        const scrollProgress =
          maxScroll > 0
            ? this.slider.scrollLeft / maxScroll
            : 0;

        this.thumb.style.width =
          `${Math.min(thumbWidth, trackWidth)}px`;

        this.thumb.style.transform =
          `translate3d(${maxThumbTravel * scrollProgress}px, 0, 0)`;
      }
    }

    customElements.define(
      'custom-featured-slider',
      CustomFeaturedSlider
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-review-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('review-marquee')) {
    class ReviewMarquee extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.custom-review-slider__track');
        this.group = this.querySelector('[data-review-group]');
        if (!this.track || !this.group) return;

        this.resizeObserver = new ResizeObserver(() => this.setup());
        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.group);
        this.setup();
        document.fonts?.ready.then(() => this.setup());
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      setup() {
        this.querySelectorAll('[data-generated-clone]').forEach((clone) => clone.remove());

        const groupWidth = this.group.getBoundingClientRect().width;
        const speed = Math.max(Number(this.dataset.speed) || 40, 1);
        if (!groupWidth) return;

        while (this.track.scrollWidth < this.clientWidth + groupWidth) {
          const clone = this.group.cloneNode(true);
          clone.removeAttribute('data-review-group');
          clone.setAttribute('data-generated-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a, button, input, select, textarea').forEach((item) => {
            item.tabIndex = -1;
          });
          this.track.appendChild(clone);
        }

        this.style.setProperty('--review-distance', `${groupWidth}px`);
        this.style.setProperty('--review-duration', `${groupWidth / speed}s`);
      }
    }

    customElements.define('review-marquee', ReviewMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-split-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('split-hero')) {
    class SplitHero extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));

        if (this.slides.length < 2) return;

        this.querySelectorAll('[data-previous]').forEach((button) => {
          button.addEventListener('click', () => this.show(this.currentIndex - 1, true));
        });
        this.querySelectorAll('[data-next]').forEach((button) => {
          button.addEventListener('click', () => this.show(this.currentIndex + 1, true));
        });
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.show(Number(dot.dataset.dot), true));
        });

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.addEventListener('shopify:block:select', (event) => {
          const selectedSlide = event.target.closest('[data-slide]');
          if (selectedSlide) this.show(Number(selectedSlide.dataset.index), true);
        });

        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      show(index, userInitiated = false) {
        const nextIndex = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === nextIndex;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        });
        this.dots.forEach((dot) => {
          const active = Number(dot.dataset.dot) === nextIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-pressed', String(active));
        });
        this.currentIndex = nextIndex;

        if (userInitiated) {
          const status = this.querySelector('[data-status]');
          if (status) status.textContent = `Slide ${nextIndex + 1} of ${this.slides.length}`;
          this.start();
        }
      }

      start() {
        this.stop();
        if (this.dataset.autoplay !== 'true') return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.timer = window.setInterval(() => this.show(this.currentIndex + 1), Number(this.dataset.speed));
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    customElements.define('split-hero', SplitHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ev-video-guides"] && !Shopify.designMode) return;
  try {
    
    if (!customElements.get('ev-video-guides')) {
        customElements.define('ev-video-guides', class extends HTMLElement {
            connectedCallback() {
                this.abort = new AbortController();
                const options = { signal: this.abort.signal };
                this.track = this.querySelector('.ev-videos__track');
                this.dialog = this.querySelector('dialog');
                this.player = this.querySelector('.ev-videos__player');
                const buttons = [...this.querySelectorAll('[data-direction]')];
                const progress = this.querySelector('.ev-videos__progress span');
                const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
                const update = () => {
                    const maximum = this.track.scrollWidth - this.track.clientWidth;
                    const position = Math.abs(this.track.scrollLeft);
                    this.querySelector('.ev-videos__controls').hidden = maximum <= 1;
                    buttons[0].disabled = position <= 1;
                    buttons[1].disabled = position >= maximum - 1;
                    const visible = this.track.clientWidth / Math.max(1, this.track.scrollWidth);
                    progress.style.transform = `scaleX(${visible + (1 - visible) * (maximum > 0 ? Math.min(position / maximum, 1) : 0)})`;
                };
                this.track.addEventListener('scroll', update, { ...options, passive: true });
                this.resize = new ResizeObserver(update);
                this.resize.observe(this.track);
                buttons.forEach(button => button.addEventListener('click', () => {
                    const direction = Number(button.dataset.direction);
                    const rtl = getComputedStyle(this.track).direction === 'rtl';
                    const position = Math.abs(this.track.scrollLeft);
                    const trackRect = this.track.getBoundingClientRect();
                    const points = [...this.track.children].map(card => {
                        const rect = card.getBoundingClientRect();
                        return position + (rtl ? trackRect.right - rect.right : rect.left - trackRect.left);
                    });
                    const target = direction > 0 ? points.find(point => point > position + 2) : points.reverse().find(point => point < position - 2);
                    this.track.scrollTo({ left: (rtl ? -1 : 1) * (target ?? (direction > 0 ? this.track.scrollWidth : 0)), behavior: reduced() ? 'instant' : 'smooth' });
                }, options));
                this.addEventListener('click', event => {
                    const link = event.target.closest('[data-video-id]');
                    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
                    const id = link.dataset.videoId;
                    if (!/^[a-zA-Z0-9_-]{11}$/.test(id)) return;
                    event.preventDefault();
                    this.opener = link;
                    const iframe = document.createElement('iframe');
                    iframe.title = link.dataset.videoTitle;
                    iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
                    iframe.allowFullscreen = true;
                    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
                    iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
                    this.player.replaceChildren(iframe);
                    this.dialog.showModal();
                }, options);
                this.querySelector('.ev-videos__close').addEventListener('click', () => this.dialog.close(), options);
                this.dialog.addEventListener('click', event => {
                    if (event.target !== this.dialog) return;
                    const rect = this.dialog.getBoundingClientRect();
                    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
                }, options);
                this.dialog.addEventListener('close', () => {
                    this.player.replaceChildren();
                    this.opener?.focus({ preventScroll: true });
                }, options);
                this.addEventListener('shopify:block:select', event => {
                    event.target.closest('.ev-videos__card')?.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'nearest' });
                }, options);
                update();
            }
            disconnectedCallback() {
                this.abort?.abort();
                this.resize?.disconnect();
                this.dialog?.close();
                this.player?.replaceChildren();
            }
        });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  if (!customElements.get('custom-related-products-slider')) {

    class CustomRelatedProductsSlider extends HTMLElement {

      connectedCallback() {
        this.slider = this.querySelector('.product-grid.slider');
        this.track = this.querySelector(
          '.related-products__scrollbar'
        );
        this.thumb = this.querySelector(
          '.related-products__scrollbar-thumb'
        );

        if (!this.slider || !this.track || !this.thumb) return;

        this.updateScrollbar =
          this.updateScrollbar.bind(this);

        this.slider.addEventListener(
          'scroll',
          this.updateScrollbar,
          { passive: true }
        );

        this.resizeObserver =
          new ResizeObserver(this.updateScrollbar);

        this.resizeObserver.observe(this.slider);
        this.resizeObserver.observe(this.track);

        requestAnimationFrame(this.updateScrollbar);
      }

      disconnectedCallback() {
        if (this.slider && this.updateScrollbar) {
          this.slider.removeEventListener(
            'scroll',
            this.updateScrollbar
          );
        }

        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }
      }

      updateScrollbar() {
        const trackWidth = this.track.clientWidth;

        const maxScroll =
          this.slider.scrollWidth -
          this.slider.clientWidth;

        const visibleRatio = Math.min(
          this.slider.clientWidth /
            this.slider.scrollWidth,
          1
        );

        const thumbWidth = Math.max(
          trackWidth * visibleRatio,
          40
        );

        const maxThumbTravel = Math.max(
          trackWidth - thumbWidth,
          0
        );

        const scrollProgress =
          maxScroll > 0
            ? this.slider.scrollLeft / maxScroll
            : 0;

        this.thumb.style.width =
          `${Math.min(thumbWidth, trackWidth)}px`;

        this.thumb.style.transform =
          `translate3d(${maxThumbTravel * scrollProgress}px, 0, 0)`;
      }

    }

    customElements.define(
      'custom-related-products-slider',
      CustomRelatedProductsSlider
    );

  }

  } catch(e) { console.error(e); }
})();
})();
